var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { Container, CssBaseline, Divider, Grid, makeStyles, Typography } from '@material-ui/core';
import { ThemeProvider } from '@material-ui/core/styles';
import { ProductImage } from '../../organisms/ProductImage';
import { Description } from '../../organisms/Description';
import { CompanyName } from '../../organisms/CompanyName';
var useStyles = makeStyles(function (theme) { return ({
    section: {
        padding: theme.spacing(1),
    },
    image: {
        width: '100%',
        height: '100%',
    },
}); });
/**
 * Atomic Design における本来の意味合いでの Template とは意味合いが異なるかもしれないが、気にしない
 */
var ExpiredTemplate = function (props) {
    var classes = useStyles();
    return (React.createElement(Container, { disableGutters: true },
        React.createElement(CssBaseline, null),
        React.createElement(Grid, { container: true, direction: "row", justifyContent: "center", alignItems: "center" },
            React.createElement(Grid, { item: true, xs: 12, className: classes.section }, props.companyImageUrl ? (React.createElement("img", { src: props.companyImageUrl, className: classes.image, alt: props.organizationName.companyName })) : (React.createElement(CompanyName, __assign({}, props.organizationName)))),
            React.createElement(Grid, { item: true, xs: 12 },
                React.createElement(Typography, { align: 'center', variant: 'body1' }, "\u3053\u306E\u30AF\u30FC\u30DD\u30F3\u306F\u6709\u52B9\u671F\u9650\u304C\u5207\u308C\u3066\u3044\u307E\u3059\u3002")),
            props.productImage ? (React.createElement(Grid, { item: true, xs: 12, className: classes.section },
                React.createElement(ProductImage, __assign({}, props.productImage)))) : (React.createElement(React.Fragment, null))),
        React.createElement(Divider, { variant: "fullWidth" }),
        React.createElement(Description, __assign({}, props.description))));
};
export var ExpiredTemplateWithTheme = function (props) {
    var theme = props.theme, data = __rest(props, ["theme"]);
    return (React.createElement(ThemeProvider, { theme: theme },
        React.createElement(ExpiredTemplate, __assign({}, data))));
};
//# sourceMappingURL=ExpiredTemplate.js.map